const apiUrl = process.env.REACT_APP_API_URL;
export const PostHorariUsuari = async (id_horari : number, id_usuari : number , page : string , id_usu_log : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/controlhorari/horari/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({ id_horari, id_usuari })
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
